const variables = {
  purple500: '#CAB3FA',
  blue700: '#77C4BB',
  grey100: '#F9F9F9',
  grey300: '#E5E5E5',
  grey500: '#555555',
  black: '#111111',
  white: '#ffffff',
  fontFamily: 'BodyFont, sans-serif',
}

// configuration reference https://echarts.apache.org/en/option.html
export const chartOptions = {
  baseOption: {
    series: [
      {
        type: 'radar',
        symbol: 'none',
        data: [
          {
            lineStyle: {
              width: 1,
            },
            areaStyle: {
              color: variables.purple500,
              opacity: 0.1,
            },
          },
          {
            lineStyle: {
              width: 1,
            },
            areaStyle: {
              color: variables.blue700,
              opacity: 0.1,
            },
          },
          // Filled through props
        ],
      },
    ],
    legend: {
      top: 'bottom',
      bottom: 30,
      selectedMode: false,
      textStyle: {
        fontFamily: variables.fontFamily,
        color: variables.black,
        fontSize: 14,
        fontWeight: 300,
        padding: 4,
      },
      itemGap: 20,
      icon: 'circle',
      itemWidth: 13,
      itemHeight: 13,
      data: [
        // Filled through props
      ],
    },
    color: [variables.purple500, variables.blue700],
    backgroundColor: 'rgba(0,0,0,0)',
    textStyle: {
      fontFamily: variables.fontFamily,
      padding: [3, 5],
    },
    silent: true,
    radar: {
      indicator: [
        // Filled through props
      ],
      animation: false,
      radius: ['22%', '80%'],
      axisName: {
        fontSize: 11,
        color: variables.grey500,
      },
      axisNameGap: 12,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitNumber: 4,
      splitLine: {
        lineStyle: {
          color: [variables.grey300],
        },
      },
      splitArea: {
        areaStyle: {
          color: [variables.grey100, variables.white],
        },
      },
    },
  },
  media: [
    {
      query: {
        maxWidth: 480,
      },
      option: {
        radar: {
          radius: ['0%', '63%'],
        },
      },
    },
  ],
}
